module.exports = __webpack_public_path__ + "6af6c77d570a6d7761794994ad272ea7.png";